module.exports = __webpack_public_path__ + "static/media/img_feature_photo1@2x.9e767ec4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_feature_photo1@2x.webp
// module id = 793
// module chunks = 0